import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { RichTextDisplay } from 'Packages/FacetDesign/Components';

export const AnalyzeYourExpensesAnswerResultOverride = buildFacetDesignOverride()
  .nameOverride('content', {
    _hideLabel: true,
    _component: () => RichTextDisplay,
    hidden: false,
  });
